module.exports = __webpack_public_path__ + "img/Noctiluca-4-mobile.440bca58.png";